import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const SuperChatLoader = ({ isAuthenticated }) => {
  const location = useLocation();
  const [chatLoaded, setChatLoaded] = useState(false);

  useEffect(() => {
    const excludedRoutes = [
      '/client/basic',
      '/client/standart',
      '/client/premium',
      '/client/ultimate',
    ];

    const isExcludedRoute = excludedRoutes.some((route) =>
      location.pathname.startsWith(route)
    );

    const existingScript = document.getElementById('superchat-script');

    // 📌 Funcție pentru eliminarea completă a SuperChat
    const removeSuperChat = () => {
      if (window.Superchat && typeof window.Superchat.destroy === 'function') {
        window.Superchat.destroy();
        console.log('✅ SuperChat instance destroyed');
      }

      // 🔥 Eliminăm TOATE elementele create de SuperChat
      document.querySelectorAll('[id^="superchat"], [class*="superchat"]').forEach((el) => {
        el.remove();
      });

      console.log('🚨 SuperChat UI elements removed from DOM');
      setChatLoaded(false);
    };

    // 🛑 Dacă ruta este exclusă sau userul este autentificat, eliminăm scriptul și UI-ul
    if (isExcludedRoute || isAuthenticated) {
      console.log('🚨 SuperChat should be removed due to exclusion or authentication');
      removeSuperChat();

      if (existingScript) {
        existingScript.remove();
        console.log('✅ SuperChat script removed');
      }

      return;
    }

    // ✅ Dacă scriptul nu există și trebuie să fie încărcat, îl adăugăm
    if (!existingScript && !chatLoaded) {
      const script = document.createElement('script');
      script.id = 'superchat-script';
      script.src = 'https://widget.superchat.de/snippet.js?applicationKey=WClo1RPmY7wBYj1ardeMpGQDL3';
      script.async = true;
      script.onload = () => {
        if (window.Superchat) {
          window.Superchat.init({
            applicationKey: 'WClo1RPmY7wBYj1ardeMpGQDL3',
          });
          console.log('✅ SuperChat initialized successfully');
          setChatLoaded(true);
        }
      };
      document.body.appendChild(script);
    }

    // 🔄 Cleanup script la schimbarea rutei
    return () => {
      if (isExcludedRoute) {
        console.log('🚨 Cleaning up SuperChat due to route change');
        setTimeout(() => {
          removeSuperChat();
          if (existingScript) {
            existingScript.remove();
          }
        }, 500); // 🔥 Timeout pentru a evita lag-ul între distrugere și re-rendare
      }
    };
  }, [location, isAuthenticated]);

  return null;
};

export default SuperChatLoader;
